module.exports = __webpack_public_path__ + "img/lens-174-plus-05.cfb869b1.png";